import React from 'react'
import '../css/WidgetOption.css'
const WidgetOptions = () => {
    return (
        <div className="widget__contents">
          <div className="widget__content">
            <img
              src="https://qphs.fs.quoracdn.net/main-thumb-ti-1737435-100-jxcfmjdvwvpkcketifttdmeeimxcatua.jpeg"
              alt=""
            />
            <div className="widget__contentTitle">
              <h5>Mobile App Programmer</h5>
              <p>The best Mobile App Development Company</p>
            </div>
          </div>
          <div className="widget__content">
            <img
              src="https://qphs.fs.quoracdn.net/main-thumb-ti-1574818-100-mzdwostcualpwcxekyrvyqqpychetdoc.jpeg"
              alt=""
            />
            <div className="widget__contentTitle">
              <h5>Full stack devlopment</h5>
              <p>Get connected latest technology usedin devloppment feild</p>
            </div>
          </div>
          <div className="widget__content">
            <img
              src="https://qphs.fs.quoracdn.net/main-thumb-ti-1644613-100-ydflucgoeztbhwyurtmlqqrgfqmjmhpl.jpeg"
              alt=""
            />
            <div className="widget__contentTitle">
              <h5>Art & Artist</h5>
              <p>A World full of soulfull singers</p>
            </div>
          </div>
          <div className="widget__content">
            <img
              src="https://qphs.fs.quoracdn.net/main-thumb-ti-1647318-100-kmwvqbpzatmylibelrowrerfqbspekwo.jpeg"
              alt=""
            />
            <div className="widget__contentTitle">
              <h5>Friedrich Nietzche</h5>
              <p>A Space dedicated to great work of Friedrich...</p>
            </div>
          </div>
          <div className="widget__content">
            <img
              src="https://qphs.fs.quoracdn.net/main-thumb-ti-1578647-100-xkggvbyzfkvzhyklewtkjijefekqbazb.jpeg"
              alt=""
            />
            <div className="widget__contentTitle">
              <h5>Stock Market Strategies</h5>
              <p>Everything about investing in Stock...</p>
            </div>
          </div>
          <div className="widget__content">
            <img
              src="https://qphs.fs.quoracdn.net/main-thumb-ti-1711686-100-glvgnbatdxpjbhrkyphlfamqrryfccvp.jpeg"
              alt=""
            />
            <div className="widget__contentTitle">
              <h5>Architecture World</h5>
              <p>All about civil architecture...</p>
            </div>
          </div>
        </div>
      );
}

export default WidgetOptions
